import { Button, Flex } from "@chakra-ui/react";
import React from "react";

export type SelectorBulkActionsProps = {
  selectedCount: number;
  totalCount: number;
  filteredCount: number;
  hasUnselectedVisibleOptions: boolean;
  onSelectVisible: () => void;
  onClearAll: () => void;
};

export function SelectorBulkActions({
  selectedCount,
  totalCount,
  filteredCount,
  hasUnselectedVisibleOptions,
  onSelectVisible,
  onClearAll,
}: SelectorBulkActionsProps) {
  return (
    <Flex
      alignItems="center"
      px={2}
      py={2}
      borderTopWidth="1px"
      borderColor="gray.300"
      backgroundColor="gray.25"
      width="full"
    >
      {hasUnselectedVisibleOptions && (
        <Button
          size="xs"
          variant="ghost"
          colorScheme="gray"
          onClick={onSelectVisible}
        >
          {filteredCount < totalCount ? "Select Visible" : "Select All"}
        </Button>
      )}

      {selectedCount > 0 && (
        <Button
          size="xs"
          variant="ghost"
          colorScheme="error"
          onClick={onClearAll}
        >
          Clear All
        </Button>
      )}
    </Flex>
  );
}
